module.exports = __webpack_public_path__ + "static/media/tangle.93ef64bb.svg";